/**
 * Маршруты трекера. Экраны появляются задачами эпика — пока все ведут на
 * заглушку, но адреса уже те, что будут в проде: их печатают в задачах,
 * коммитах и уведомлениях, и менять их потом дороже, чем договориться сразу.
 *
 * Проектные экраны живут под `/p/:key/…` — ключ проекта (DEV, SALES) читается
 * в адресной строке и совпадает с префиксом ключей задач.
 */
import { createRouter, createWebHistory } from 'vue-router'

import { setupAuthGuard } from '@/features/auth/guard'
import AppLayout from '@/layouts/AppLayout.vue'
import ForbiddenView from '@/views/ForbiddenView.vue'
import LoginView from '@/views/LoginView.vue'
import NotFoundView from '@/views/NotFoundView.vue'
import PlaceholderView from '@/views/PlaceholderView.vue'

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { path: '/login', name: 'login', component: LoginView, meta: { public: true } },
    {
      path: '/',
      component: AppLayout,
      children: [
        { path: '', redirect: '/my' },
        { path: 'my', name: 'my-tasks', component: PlaceholderView, meta: { titleKey: 'views.myTasks' } },
        { path: 'projects', name: 'projects', component: PlaceholderView, meta: { titleKey: 'views.epics' } },
        { path: 'calendar', name: 'calendar', component: PlaceholderView, meta: { titleKey: 'views.calendar' } },
        { path: 'devops', name: 'devops', component: PlaceholderView, meta: { titleKey: 'views.devops' } },
        { path: 'kb', name: 'knowledge', component: PlaceholderView, meta: { titleKey: 'views.knowledge' } },
        { path: 'p/:key/board', name: 'board', component: PlaceholderView, meta: { titleKey: 'views.board' } },
        { path: 'p/:key/issues', name: 'issues', component: PlaceholderView, meta: { titleKey: 'views.issues' } },
        { path: 'p/:key/epics', name: 'epics', component: PlaceholderView, meta: { titleKey: 'views.epics' } },
        {
          path: 'p/:key/settings',
          name: 'project-settings',
          component: PlaceholderView,
          meta: { titleKey: 'views.settings' },
        },
        { path: '403', name: 'forbidden', component: ForbiddenView },
        // Внутри лэйаута, а не отдельным экраном: пользователь вошёл, и
        // сайдбар с навигацией — единственный способ уйти отсюда, не набирая
        // адрес руками.
        { path: ':pathMatch(.*)*', name: 'not-found', component: NotFoundView },
      ],
    },
  ],
})

setupAuthGuard(router)

export default router
